import React from "react";
import {
  CalendarIcon,
  DocumentTextIcon,
  ChartBarIcon,
  PresentationChartLineIcon,
  BookOpenIcon,
  Cog6ToothIcon,
  ChatBubbleLeftRightIcon,
  ArrowsRightLeftIcon,
  ChatBubbleBottomCenterTextIcon,
  ClipboardDocumentCheckIcon,
  ShieldCheckIcon,
  LinkIcon,
} from "@heroicons/react/24/outline";

export const ADMIN_EMAILS = ["bandwithsam@gmail.com", "samuelharting.work@gmail.com"];

export const isAdminEmail = (email) => {
  if (!email) return false;
  const normalizedEmail = email.toLowerCase().trim();
  return ADMIN_EMAILS.some(
    (adminEmail) => adminEmail.toLowerCase().trim() === normalizedEmail
  );
};

export const getNavGroups = (currentMonthPath) => [
  {
    label: "Core Journal",
    items: [
      {
        label: "Calendar",
        path: currentMonthPath,
        icon: <CalendarIcon className="w-4 h-4" />,
        matchPaths: ["/", "/month", "/day"],
      },
      {
        label: "Trades",
        path: "/trades",
        icon: (
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <polyline points="2,18 7,10 11,14 15,6 22,13" />
            <polyline points="19,13 22,13 22,10" />
          </svg>
        ),
      },
      {
        label: "Notebook",
        path: "/notebook",
        icon: <BookOpenIcon className="w-4 h-4" />,
        dividerAfter: true,
      },
      {
        label: "Summary",
        path: "/summary",
        icon: <ChartBarIcon className="w-4 h-4" />,
      },
      {
        label: "Export",
        path: "/context",
        icon: <DocumentTextIcon className="w-4 h-4" />,
      },
      {
        label: "Analytics",
        path: "/visualize",
        icon: <PresentationChartLineIcon className="w-4 h-4" />,
      },
    ],
  },
  {
    label: "Market & Tools",
    items: [
      {
        label: "Terminal",
        path: "/terminal",
        icon: (
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <rect x="2" y="3" width="9" height="7" rx="1" />
            <rect x="13" y="3" width="9" height="7" rx="1" />
            <rect x="2" y="12" width="9" height="7" rx="1" />
            <rect x="13" y="12" width="9" height="7" rx="1" />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 6.5h7M4.5 9.5h5M13.5 6.5h7M13.5 9.5h5M4.5 15.5h7M4.5 18.5h5M13.5 15.5h7M13.5 18.5h5"
            />
          </svg>
        ),
      },
      {
        label: "BandzBot",
        path: "/bandzbot",
        icon: <ChatBubbleBottomCenterTextIcon className="w-4 h-4" />,
      },
      {
        label: "Checklist",
        path: "/checklist",
        icon: <ClipboardDocumentCheckIcon className="w-4 h-4" />,
      },
    ],
  },
  {
    label: "Account & Settings",
    items: [
      {
        label: "Connections",
        path: "/connections",
        icon: <LinkIcon className="w-4 h-4" />,
        matchPaths: ["/connections"],
      },
      {
        label: "Activity",
        path: "/account-activity",
        icon: <ArrowsRightLeftIcon className="w-4 h-4" />,
        matchPaths: ["/account-activity", "/deposit", "/payout"],
      },
      {
        label: "Settings",
        path: "/settings",
        icon: <Cog6ToothIcon className="w-4 h-4" />,
      },
    ],
  },
  {
    label: "Community",
    items: [
      {
        label: "Socials",
        path: "/socials",
        icon: (
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
            <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
          </svg>
        ),
      },
      {
        label: "Feedback",
        path: "/feedback",
        icon: <ChatBubbleLeftRightIcon className="w-4 h-4" />,
      },
    ],
  },
];

export const adminNavItem = {
  label: "Admin",
  path: "/admin",
  icon: <ShieldCheckIcon className="w-4 h-4" />,
};
